import { ShieldCheck } from 'lucide-react';
import { buildCoreSecurityNavItems } from '@/components/layout/NavBar/nav-items';
import { useActiveOrgSlug } from '@/lib/useOrgRoutes';
import { ResourceGroupOverviewPage } from '@/pages/resources/ResourceGroupOverviewPage';

/**
 * Landing page for the Security drill group (`/{slug}/security`). Mirrors
 * the Misc/Integrations overviews: renders the core Security nav items
 * (personal Model Providers) alongside any plugin-contributed
 * `group: 'security'` pages as cards (MCP Servers, AI Gateways, Tailscale).
 * Without this, clicking the Security section header routed to `/security`
 * with no matching route (404).
 */
export function SecurityOverviewPage() {
  const slug = useActiveOrgSlug();
  return (
    <ResourceGroupOverviewPage
      icon={<ShieldCheck className="h-5 w-5" />}
      title="Security"
      description="Manage the model API keys, credentials, and connections available to your agents."
      coreNavItems={buildCoreSecurityNavItems(slug)}
      group="security"
    />
  );
}
